import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import styled from "styled-components";
import { Button } from "../../../components";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { useCustodianTransactionMatching } from "../hooks/CustodianTransactionMatchingContext";
import useHubwiseTransactions from "../hooks/useHubwiseTransactions";
import HubwiseTransactionsGrid from "./HubwiseTransactionsGrid";
import { FormInput } from "../../../components/forms";

const ModalBody = styled(Modal.Body)`
    ${({ totalCount }) => totalCount > 0
        && `
    min-height: 66.67vh;
    max-height: 66.67vh;
    display: flex;
    flex-direction: column;
    padding: 0;
`}
`;

const HubwiseTransactionsModal = ({ show, onHide }) => {

    const {
        retryTransactionMatching,
        patchTransaction
    } = useCustodianTransactionMatching();

    const transactionsResult = useHubwiseTransactions();
    const { totalCount } = transactionsResult;

    const onRefresh = () => {
        onHide();
        return toast.promise(
            retryTransactionMatching(),
            {
                loading: "Retrying Transaction Matching with modified transactions...",
                success: "Transaction Matches regenerated!",
                error: (err) => {
                    console.error(err);
                    return "Failed to retry Transaction Matching Process."
                }
            }
        );
    }

    return <Modal show={show} onHide={onHide} centered backdrop="static" size="xl">
        <ThemedModal.Header closeButton>
            <Modal.Title>Hubwise Transactions</Modal.Title>
        </ThemedModal.Header>
        <ModalBody totalCount={totalCount}>
            <div className="px-3 py-4" style={{ flex: '1 1 auto' }}>
                <HubwiseTransactionsGrid patchTransaction={patchTransaction} {...transactionsResult} />
            </div>
        </ModalBody>
        <Modal.Footer>
            <FormInput
                placeholder="Search..."
                disableAnimations
                value={transactionsResult.search}
                onBlur={value => transactionsResult.setSearch(value)}
                className="me-3"
                clearable
            />
            {
                totalCount > 0
                    ? <Button variant="success" onClick={onRefresh}>
                        Confirm and Retry Matching
                    </Button>
                    : <Button variant="light" onClick={onHide}>Close</Button>
            }
        </Modal.Footer>
    </Modal>
}

export default HubwiseTransactionsModal;